import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useApi } from "../contexts/ApiContext";

const textToArray = (text) =>
  text
    ?.split("\n")
    ?.map((t) => t.trim())
    ?.filter(Boolean);

const useJobApplication = ({ jobPostingId, skip }) => {
  const { api } = useApi();
  const { t } = useTranslation();
  const ACKNOWLEDGEMENT_TEXT = [
    t("eeoQuestions.ackowledgementText1"),
    t("eeoQuestions.ackowledgementText2"),
    t("eeoQuestions.ackowledgementText3"),
  ];
  const EEO_INTRO_TEXT = [t("eeoQuestions.introText")];
  const [jobAppResponse, setJobAppResponse] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!jobPostingId || skip) {
      return;
    }
    setLoading(true);
    api
      .getApplicationItems(jobPostingId)
      .then((q) => {
        setJobAppResponse(q.data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [api, jobPostingId, skip]);

  return {
    acknowledgementText:
      textToArray(jobAppResponse?.acknowledgement_text) || ACKNOWLEDGEMENT_TEXT,
    eeoIntroText: textToArray(jobAppResponse?.eeo_intro_text) || EEO_INTRO_TEXT,
    eeoPageAvailable: jobAppResponse?.eeo_page_available || false,
    questions: jobAppResponse?.questions || [],
    loading,
  };
};

export default useJobApplication;
